import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useFacet } from '~/composables/_next/useFacet';
import { parseAttraqtResult, parseCategory } from '~/components/Layout/Search/helpers/parseResult';
import SearchList from '~/components/Layout/Search/components/SearchList.vue';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import { useAttraqtSearch } from '@/composables/attraqt/useAttraqtIntegration';
import { useLocalization } from '~/composables/_next/useLocalization';
import useRightPath from '~/composables/useRightPath';
import { PAGE_TYPES_TO_ROUTES, ContentfulRouteNames } from '~/constants/RoutesEnums';
import { TabsNames } from '~/types/SearchConst';
import { watchDebounced, onClickOutside } from '@vueuse/core';
import useIsHome from '~/composables/useIsHome';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import AzButtonText from '~/components/_next/atoms/AzButtonText.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchOverlayOrganism',
  props: {
    isOverlayOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open', 'close'],
  setup: function setup(__props, _ref) {
    var expose = _ref.expose,
      emit = _ref.emit;
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      $sentry = _useNuxt2App.$sentry,
      app = _useNuxt2App.app,
      i18n = _useNuxt2App.i18n;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
    var route = useRoute();
    var router = useRouter();
    var _useIsHome = useIsHome(),
      isHome = _useIsHome.isHome;
    var _useFacet = useFacet('search'),
      categoriesResult = _useFacet.result,
      categoriesSearch = _useFacet.search;
    var _useAttraqtSearch = useAttraqtSearch('searchOverlay-products'),
      productsResult = _useAttraqtSearch.result,
      productsSearch = _useAttraqtSearch.search;
    var _useAttraqtSearch2 = useAttraqtSearch('searchOverlay-recipes'),
      recipesResult = _useAttraqtSearch2.result,
      recipesSearch = _useAttraqtSearch2.search;
    var _useAttraqtSearch3 = useAttraqtSearch('searchOverlay-advices'),
      advicesResult = _useAttraqtSearch3.result,
      advicesSearch = _useAttraqtSearch3.search;
    var isSearchPage = computed(function () {
      var _route$name$startsWit, _route$name;
      return (_route$name$startsWit = route === null || route === void 0 ? void 0 : (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.startsWith('search-term___')) !== null && _route$name$startsWit !== void 0 ? _route$name$startsWit : false;
    });
    var links = computed(function () {
      return {
        recipes: app.localePath({
          name: 'search-term',
          params: {
            term: query.value
          },
          query: {
            type: TabsNames.Recipes
          }
        }),
        products: app.localePath({
          name: 'search-term',
          params: {
            term: query.value
          },
          query: {
            type: TabsNames.Products
          }
        }),
        advices: app.localePath({
          name: 'search-term',
          params: {
            term: query.value
          },
          query: {
            type: TabsNames.Advices
          }
        })
      };
    });
    var ctaLabels = computed(function () {
      var _productsResult$value, _productsResult$value2, _productsResult$value3, _productsResult$value4, _recipesResult$value$, _recipesResult$value, _recipesResult$value$2, _recipesResult$value$3, _advicesResult$value$, _advicesResult$value, _advicesResult$value$2, _advicesResult$value$3;
      var products = ((_productsResult$value = (_productsResult$value2 = productsResult.value) === null || _productsResult$value2 === void 0 ? void 0 : (_productsResult$value3 = _productsResult$value2.data) === null || _productsResult$value3 === void 0 ? void 0 : (_productsResult$value4 = _productsResult$value3.metadata) === null || _productsResult$value4 === void 0 ? void 0 : _productsResult$value4.count) !== null && _productsResult$value !== void 0 ? _productsResult$value : 0) > 4 ? i18n.tc('search.seeProducts', productsResult.value.data.metadata.count, {
        count: productsResult.value.data.metadata.count
      }) : '';
      var recipes = ((_recipesResult$value$ = (_recipesResult$value = recipesResult.value) === null || _recipesResult$value === void 0 ? void 0 : (_recipesResult$value$2 = _recipesResult$value.data) === null || _recipesResult$value$2 === void 0 ? void 0 : (_recipesResult$value$3 = _recipesResult$value$2.metadata) === null || _recipesResult$value$3 === void 0 ? void 0 : _recipesResult$value$3.count) !== null && _recipesResult$value$ !== void 0 ? _recipesResult$value$ : 0) > 4 ? i18n.tc('search.seeRecipes', recipesResult.value.data.metadata.count, {
        count: recipesResult.value.data.metadata.count
      }) : '';
      var advices = ((_advicesResult$value$ = (_advicesResult$value = advicesResult.value) === null || _advicesResult$value === void 0 ? void 0 : (_advicesResult$value$2 = _advicesResult$value.data) === null || _advicesResult$value$2 === void 0 ? void 0 : (_advicesResult$value$3 = _advicesResult$value$2.metadata) === null || _advicesResult$value$3 === void 0 ? void 0 : _advicesResult$value$3.count) !== null && _advicesResult$value$ !== void 0 ? _advicesResult$value$ : 0) > 4 ? i18n.tc('search.seeAdvices', advicesResult.value.data.metadata.count, {
        count: advicesResult.value.data.metadata.count
      }) : '';
      return {
        products: products,
        recipes: recipes,
        advices: advices
      };
    });
    var container = ref();
    var searchBar = ref(null);
    var mobileSearchBar = ref(null);
    var input = ref(route.params.term);
    var query = ref(route.params.term);
    var clearSearch = function clearSearch() {
      input.value = '';
    };
    var openResults = function openResults() {
      if (input.value) {
        trackDynamicYieldEvent({
          name: 'Keyword Search',
          properties: {
            dyType: 'keyword-search-v1',
            keywords: input.value
          }
        });
        router.push(app.localePath({
          name: 'search-term',
          params: {
            term: input.value
          }
        }));
        close();
      }
    };
    var attraqtMask = 'id, product(title, price, photo, url, l10n, categoryNames, category, mainCategory, contentTypeId)';
    var hasTypedEnough = computed(function () {
      var _input$value;
      return (input === null || input === void 0 ? void 0 : (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.length) >= 3;
    });
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var _useLazyAsyncData = useLazyAsyncData('search-overlay', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _input$value2, _productsResult$value5, _productsResult$value6, _productsResult$value7, _productsResult$value8, _productsResult$value9;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!hasTypedEnough.value) {
                _context.next = 11;
                break;
              }
              query.value = (_input$value2 = input.value) !== null && _input$value2 !== void 0 ? _input$value2 : '';
              _context.next = 4;
              return Promise.all([categoriesSearch({
                filters: {},
                page: 1,
                perPage: 20,
                sort: 'latest',
                phrase: query.value
              }), productsSearch({
                query: query.value,
                options: {
                  customResponseMask: attraqtMask,
                  limit: 3,
                  filter: 'kind=product',
                  facets: [{
                    id: 'facet-availableInCountries',
                    values: ['ALL', country]
                  }, {
                    id: 'kind-type',
                    values: ['product']
                  }]
                }
              }), recipesSearch({
                query: query.value,
                options: {
                  customResponseMask: attraqtMask,
                  limit: 3,
                  filter: 'kind=recipe',
                  facets: [{
                    id: 'kind-type',
                    values: ['recipe']
                  }]
                }
              }), advicesSearch({
                query: query.value,
                options: {
                  customResponseMask: attraqtMask,
                  limit: 3,
                  filter: 'kind=article',
                  facets: [{
                    id: 'kind-type',
                    values: ['article']
                  }]
                }
              })]);
            case 4:
              if (!((_productsResult$value5 = productsResult.value) !== null && _productsResult$value5 !== void 0 && (_productsResult$value6 = _productsResult$value5.data) !== null && _productsResult$value6 !== void 0 && (_productsResult$value7 = _productsResult$value6.items) !== null && _productsResult$value7 !== void 0 && (_productsResult$value8 = _productsResult$value7[0]) !== null && _productsResult$value8 !== void 0 && (_productsResult$value9 = _productsResult$value8.redirect) !== null && _productsResult$value9 !== void 0 && _productsResult$value9.url)) {
                _context.next = 8;
                break;
              }
              close();
              _context.next = 9;
              break;
            case 8:
              return _context.abrupt("return", {
                categories: parseCategory(categoriesResult.value),
                products: parseAttraqtResult(productsResult.value, getProductPath),
                recipes: parseAttraqtResult(recipesResult.value, function (item) {
                  var _item$product;
                  return {
                    name: PAGE_TYPES_TO_ROUTES[item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.contentTypeId] || ContentfulRouteNames.Recipe,
                    params: {
                      slug: item.product.url
                    }
                  };
                }),
                advices: parseAttraqtResult(advicesResult.value, function (item) {
                  return {
                    name: 'page-slug',
                    params: {
                      slug: item.product.url
                    }
                  };
                })
              });
            case 9:
              _context.next = 12;
              break;
            case 11:
              return _context.abrupt("return", {
                categories: [],
                products: [],
                recipes: [],
                advices: []
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })), {
        server: false,
        immediate: false
      }),
      results = _useLazyAsyncData.data,
      search = _useLazyAsyncData.execute;
    var showNoResults = ref(false);
    watchDebounced(input, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _results$value, _results$value$produc, _results$value2, _results$value2$recip, _results$value3, _results$value3$advic;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return search();
          case 2:
            showNoResults.value = hasTypedEnough.value && !((_results$value = results.value) !== null && _results$value !== void 0 && (_results$value$produc = _results$value.products) !== null && _results$value$produc !== void 0 && _results$value$produc.length) && !((_results$value2 = results.value) !== null && _results$value2 !== void 0 && (_results$value2$recip = _results$value2.recipes) !== null && _results$value2$recip !== void 0 && _results$value2$recip.length) && !((_results$value3 = results.value) !== null && _results$value3 !== void 0 && (_results$value3$advic = _results$value3.advices) !== null && _results$value3$advic !== void 0 && _results$value3$advic.length);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), {
      debounce: 500,
      maxWait: 1000
    });
    function open() {
      emit('open');
    }
    function close() {
      emit('close');
    }
    onClickOutside(container, function () {
      close();
    });

    /**
     * Focuses the mobile search bar input field.
     *
     * This function waits for the next DOM update using `nextTick` before querying
     * the mobile search bar input and focusing on it. It ensures that the element
     * exists in the DOM before attempting to apply focus.
     *
     * @returns {void}
     */
    function focusMobileSearchbar() {
      nextTick(function () {
        var _mobileSearchBar$valu;
        var input = (_mobileSearchBar$valu = mobileSearchBar.value) === null || _mobileSearchBar$valu === void 0 ? void 0 : _mobileSearchBar$valu.$el.querySelector('input');
        if (!input) {
          $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(new Error('input is null while attempting to focus mobile SearchBar'));
          return;
        }
        input.focus();
      });
    }
    function hasLessThanThreeData(obj) {
      var keysToCheck = ['categories', 'products', 'recipes', 'advices'];
      var nonEmptyCount = keysToCheck.filter(function (key) {
        var _obj$key$length, _obj$key;
        return ((_obj$key$length = (_obj$key = obj[key]) === null || _obj$key === void 0 ? void 0 : _obj$key.length) !== null && _obj$key$length !== void 0 ? _obj$key$length : 0) > 0;
      }).length;
      return nonEmptyCount < 3;
    }

    /**
     * Clears the search input and closes the search field.
     */
    function crossActionClearAndClose() {
      clearSearch();
      close();
    }

    /**
     * Handles the global "Escape" key press event.
     *
     * When the user presses the Escape key, this function triggers the `close()` method
     * to close the search overlay. It is used to allow keyboard users to dismiss
     * the overlay without a mouse.
     *
     * @param {KeyboardEvent} event - The keyboard event object.
     * @returns {void}
     */
    function handleEscape(event) {
      if (event.key === 'Escape') {
        close();
      }
    }
    onMounted(function () {
      var desktopSearchBar = searchBar.value.$el.querySelector('input');
      desktopSearchBar.addEventListener('click', focusMobileSearchbar);
      window.addEventListener('keydown', handleEscape);
    });
    onBeforeUnmount(function () {
      var desktopSearchBar = searchBar.value.$el.querySelector('input');
      desktopSearchBar.removeEventListener('click', focusMobileSearchbar);
      window.removeEventListener('keydown', handleEscape);
    });
    watch(function () {
      return props.isOverlayOpen;
    }, function (newVal, oldVal) {
      if (newVal && !oldVal) {
        focusMobileSearchbar();
      }
    });
    expose({
      open: open,
      close: close
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $sentry: $sentry,
      app: app,
      i18n: i18n,
      getProductPath: getProductPath,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      route: route,
      router: router,
      isHome: isHome,
      categoriesResult: categoriesResult,
      categoriesSearch: categoriesSearch,
      productsResult: productsResult,
      productsSearch: productsSearch,
      recipesResult: recipesResult,
      recipesSearch: recipesSearch,
      advicesResult: advicesResult,
      advicesSearch: advicesSearch,
      isSearchPage: isSearchPage,
      links: links,
      ctaLabels: ctaLabels,
      container: container,
      searchBar: searchBar,
      mobileSearchBar: mobileSearchBar,
      input: input,
      query: query,
      clearSearch: clearSearch,
      openResults: openResults,
      attraqtMask: attraqtMask,
      hasTypedEnough: hasTypedEnough,
      country: country,
      results: results,
      search: search,
      showNoResults: showNoResults,
      open: open,
      close: close,
      focusMobileSearchbar: focusMobileSearchbar,
      hasLessThanThreeData: hasLessThanThreeData,
      crossActionClearAndClose: crossActionClearAndClose,
      handleEscape: handleEscape,
      AzIcon: AzIcon,
      SearchList: SearchList,
      AzInput: AzInput,
      AzButtonText: AzButtonText
    };
  }
});